// extracted by mini-css-extract-plugin
export var measureBox = "_2r-0";